"use client"

import { useParams } from "next/navigation"
import { t as _t, type UiKey } from "./ui"

/**
 * Client-side translator hook. Reads `countryCode` from the active route
 * params and resolves UI dictionary keys against it.
 *
 *   const t = useT()
 *   <button>{t("catalog")}</button>
 */
export function useT() {
  const params = useParams()
  const cc = params?.countryCode as string | undefined
  return (key: UiKey) => _t(cc, key)
}
